const POLICY_STATUS = {
  PURCHASED: "PURCHASED",
  CONTINUE_PURCHASE: "CONTINUE_PURCHASE",
};

export default POLICY_STATUS;
